<!--
 * @Description: 功能描述
 * @Version: 1.0
 * @Author: Yuchuan
 * @Date: 2022-01-18 15:52:48
-->
<template>
  <div id="app" data-server-rendered="true">
    <!-- 1.头部导航 -->
    <yp-navbar ref="navbar" class="no-transparent-navbar" mobileTitle="悦朋印象"></yp-navbar>
    <!-- 2.背景图 + 标题 -->
    <page-title-bg first-font="j" title-en="OIN US" title-zh="加入我们"></page-title-bg>
    <!-- 3.面包屑导航 -->
    <div class="bread-crumbs-container hidden-xs">
      <div class="container">
        <ol class="breadcrumb">
          <li><a href="/index.html">首页</a></li>
          <li><a href="/friendsImpression.html">加入悦朋</a></li>
          <li class="active">悦朋印象</li>
        </ol>
      </div>
    </div>
    <!-- 4.企业简介 -->
    <section class="enterprise-profile-container">
      <div class="sec-title-container">
        <div class="sec-title-zh">悦朋福利</div>
        <div class="sec-title-en">YUEPENG WELFARE</div>
      </div>
      <!-- 悦朋福利 -->
      <div class="welfare-class">
        <div
          v-for="(item, index) in welfareList"
          :key="index"
          :class="mouserindex == index ? 'background-img animate__animated animate__fadeIn' : 'welfare-class-content'"
          @mouseover="mouserindexEvent(index)"
          @mouseout="mouserOutEvent"
        >
          <!-- <div class="background-img"> -->
          <div :class="'background-img-box ' + item.className">
            <div v-if="index !== mouserindex"><img class="icon-class" :src="item.img" alt="" /></div>
            <div class="welfare-content-title">{{ item.title }}</div>
            <div v-if="index == mouserindex" class="welfare-content-content">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <!-- 内容图片展示 -->
      <div class="content-class-box">
        <div class="content-class-img">
          <!-- 头部区域占领 -->
          <div class="content-div"></div>
          <div class="content-class-hose">
            <img class="bangzhu-img" src="../../../public/static/img/bangzhu.png" alt="" />
            <div></div>
            <div class="cont-class-center">
              <div class="center-box">
                <div class="content-title">悦朋生活</div>
                <div class="content-title-sceond">YUEPENG LIFE</div>
                <div class="content-title-three">一年一度的总结年会 是悦朋人的骄傲</div>
              </div>
            </div>
            <div>
              <img class="shen-img" src="../../../public/static/img/shenzong.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="img-display">
        <div></div>
        <div></div>
      </div>
      <!-- 轮播区域 -->
      <div class="loop-box">
        <div class="loop-img-box">
          <div class="loop-img"></div>
          <ul class="loop-ul" id="loopUl">
            <li v-for="item in scrollDataListSecond" :key="item.id">
              <img class="loop-ul-img" :src="item.img" alt="" />
            </li>
          </ul>
        </div>
        <div class="page-now-second">
          <div @click="beforeEvent"><img class="page-icon-class" src="../../../public/static/img/pointleft.png" alt="" /></div>
          <div class="page-now-size">{{ pageNowsecond }} / 3</div>
          <div @click="nextEvent"><img class="page-icon-class" src="../../../public/static/img/pointright.png" alt="" /></div>
        </div>
        <div class="page-now-three">团建活动</div>
        <div class="page-now-four">
          <div>
            <div>GROUP</div>
            <div>BUILDING</div>
            <div>ACTIVITIES</div>
          </div>
        </div>
      </div>
      <!-- 活动展示区域 -->
      <div class="activity-show">
        <div>
          <img class="meeting-room-class" src="../../../public/static/img/meetingRoom.png" alt="" />
        </div>
        <div class="activity-show-secondeBox">
          <div><img class="meeting-room-two" src="../../../public/static/img/meetingRoomtwo.png" alt="" /></div>
          <div class="activity-show-second">
            <div><img class="graphics-class" src="../../../public/static/img/graphics.png" alt="" /></div>
            <div><img class="graphics-class" src="../../../public/static/img/programmer.png" alt="" /></div>
          </div>
        </div>
        <div class="activity-show-threeBox">
          <div>
            <img class="gift-class" src="../../../public/static/img/gift.png" alt="" />
          </div>
          <div class="activity-show-right"></div>
        </div>
      </div>
    </section>
    <!-- 动态弹框 -->
    <!-- 7.footer -->
    <yp-footer></yp-footer>
  </div>
</template>
<script>
import YpNavbar from '@/components/navbar.vue'
import PageTitleBg from '@/components/page-title-bg.vue'
import YpFooter from '@/components/footer.vue'
export default {
  components: {
    YpNavbar,
    PageTitleBg,
    YpFooter,
  },
  data() {
    return {
      pageNowsecond: 1,
      scrollDataListSecond: [],
      scrollData: [
        { img: require('../../../public/static/img/5.png') },
        { img: require('../../../public/static/img/2.png') },
        { img: require('../../../public/static/img/3.png') },
        { img: require('../../../public/static/img/4.png') },
        { img: require('../../../public/static/img/4.png') },
        { img: require('../../../public/static/img/4.png') },
        { img: require('../../../public/static/img/4.png') },
        { img: require('../../../public/static/img/4.png') },
        { img: require('../../../public/static/img/4.png') },
      ],
      mouserindex: '10',
      // 悦朋福利列表
      welfareList: [
        {
          img: require('../../../public/static/img/socialInsurance.png'),
          title: '社会保险',
          content: '公司为员工缴纳养老、医疗、工伤、失业、生育保险，给员工提供安心的社会保障。',
          className: 'img-socialInsurancebc',
        },
        {
          img: require('../../../public/static/img/housingAccumulaton.png'),
          title: '住房公积金',
          content: '为帮助员工减轻住房压力，为员工缴纳住房公积金，在员工有购房消费需求时，住房公积金可以助员工圆住房梦。',
          className: 'img-housingAccumulaton',
        },
        {
          img: require('../../../public/static/img/commercialInsurance.png'),
          title: '商业保险',
          content: '公司为每一位员工购买商业意外保险，保险费用由公司全额支付。',
          className: 'img-commercialInsurance',
        },
        {
          img: require('../../../public/static/img/holidayGreetings.png'),
          title: '节日问候',
          content: '中秋、端午每个特殊的节日，公司会为您精心提供一份节日福利。',
          className: 'img-holidayGreetings',
        },
        {
          img: require('../../../public/static/img/birthdayPresent.png'),
          title: '生日礼物',
          content: '为每个特别的你奉上一份生日蛋糕。',
          className: 'img-birthdayPresent',
        },
        {
          img: require('../../../public/static/img/paidVacation.png'),
          title: '带薪假期',
          content: '为了保障悦朋人的工作与生活平衡，提供了多样的带薪假期：如调休假、病假、孕期检查假，同时也享受法定的：产假、陪产假、婚假等。',
          className: 'img-paidVacation',
        },
        {
          img: require('../../../public/static/img/fitnessField.png'),
          title: '健身场地',
          content: '园区大楼四楼配备有多样的健身器材，工作之余还可以强身健体',
          className: 'img-fitnessField',
        },
        {
          img: require('../../../public/static/img/medicalStaff.png'),
          title: '员工体检',
          content: '公司提供两年一度的身体健康检查，全面检测大家的身体状况，尽早预防各类健康风险。',
          className: 'img-medicalStaff',
        },
      ],
    }
  },
  created() {
    Media($(window).width())
    function Media(width) {
      if (width > 750) {
        refreshRem(1920)
      } else {
        refreshRem(750)
      }
    }
    // 根据设计图尺寸计算rem
    function refreshRem(designSize) {
      let html = document.documentElement
      let wW = html.clientWidth // 窗口宽度
      let rem = (wW * 100) / designSize
      document.documentElement.style.fontSize = rem + 'px'
    }
    this.pageCountSecond()
  },

  methods: {
    // nextEvent() {
    //   var oUl = document.getElementById('loopUl')
    //   var Li = oUl.getElementsByTagName('li') //获取ul下的所有li
    //   oUl.innerHTML = oUl.innerHTML + oUl.innerHTML //li下的内容进行想加
    //   oUl.style.width = Li[0].offsetWidth * Li.length + 'px' //ul的宽度等于每个li的宽度乘以所有li的长度
    //   //主方法
    //   function move() {
    //     oUl.style.left = oUl.offsetWidth - 1210 + 'px'
    //     //如果左边横向滚动了长度一半之后,回到初始位置
    //   }
    //   //调用方法
    //   setInterval(move, 300)
    // },
    nextEvent() {
      if (this.pageNowsecond >= 3) {
        // 最后一页
      } else {
        this.pageNowsecond++
        this.pageCountSecond()
      }
    },
    beforeEvent() {
      if (this.pageNowsecond <= 1) {
        // 最后一页
      } else {
        this.pageNowsecond--
        this.pageCountSecond()
      }
    },
    pageCountSecond() {
      var pageBagin = (this.pageNowsecond - 1) * 4
      var pageEnd = pageBagin + 3
      this.scrollDataListSecond = this.scrollData.filter((item, index) => {
        return index >= pageBagin && index <= pageEnd
      })
    },
    // 鼠标滑动事件
    mouserindexEvent(index) {
      this.mouserindex = index
    },

    mouserOutEvent() {
      this.mouserindex = 9
    },
  },
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
